export const ICON_ADVERTISERS_LIST = './assets/media/icons/duotune/files/fil001.svg';
export const ICON_ARROW_LEFT = './assets/media/icons/duotune/arrows/arr063.svg';
export const ICON_BANNER_BARCODE = './assets/media/icons/app/barcode.svg';
export const ICON_BANNER = './assets/media/icons/duotune/layouts/lay010.svg';
export const ICON_CALENDAR = './assets/media/icons/duotune/general/gen014.svg';
export const ICON_CHECK = './assets/media/icons/duotune/arrows/arr012.svg';
export const ICON_CHECK_CIRCLE = './assets/media/icons/duotune/general/gen043.svg';
export const ICON_CHECK_ONE_COLOR = './assets/media/icons/app/check-one-color.svg';
export const ICON_CHEVRON_UP = './assets/media/icons/duotune/arrows/arr073.svg';
export const ICON_CHEVRON_DOWN = './assets/media/icons/duotune/arrows/arr072.svg';
export const ICON_CHEVRON_LEFT = './assets/media/icons/duotune/arrows/arr074.svg';
export const ICON_CHEVRON_RIGHT = './assets/media/icons/duotune/arrows/arr071.svg';
export const ICON_CLEAR = './assets/media/icons/duotune/general/gen027.svg';
export const ICON_CLOSE = './assets/media/icons/duotune/arrows/arr011.svg';
export const ICON_CLOSE_CIRCLE = './assets/media/icons/duotune/general/gen040.svg';
export const ICON_SEARCH = './assets/media/icons/duotune/general/gen021.svg';
export const ICON_CODE = './assets/media/icons/duotune/coding/cod003.svg';
export const ICON_COPY = './assets/media/icons/duotune/general/gen028.svg';
export const ICON_CURSOR = './assets/media/icons/duotune/coding/cod006.svg';
export const ICON_DISPLAY = './assets/media/icons/app/barcode.svg';
export const ICON_DOCUMENT = './assets/media/icons/duotune/general/gen005.svg';
export const ICON_DOWNLOAD = './assets/media/icons/app/download.svg';
export const ICON_EDIT = './assets/media/icons/duotune/art/art005.svg';
export const ICON_ERROR = './assets/media/icons/duotune/general/gen044.svg';
export const ICON_FUNNEL = './assets/media/icons/duotune/general/gen031.svg';
export const ICON_GEAR = './assets/media/icons/duotune/coding/cod001.svg';
export const ICON_INFO = './assets/media/icons/duotune/general/gen045.svg';
export const ICON_PLUS = './assets/media/icons/duotune/arrows/arr009.svg';
export const ICON_PREVIEW = './assets/media/icons/app/eye.svg';
export const ICON_PRODUCT_DOUBLE = './assets/media/icons/duotune/general/gen009.svg';
export const ICON_PRODUCT = './assets/media/icons/duotune/layouts/lay001.svg';
export const ICON_QUESTION_MARK = './assets/media/icons/duotune/general/gen046.svg';
export const ICON_REFRESH = './assets/media/icons/duotune/arrows/arr029.svg';
export const ICON_THREE_DOTS = './assets/media/icons/duotune/general/gen052.svg';
export const ICON_USERS = './assets/media/oh-icons/users.svg';
export const ICON_ACTIVATE = './assets/media/icons/duotune/arrows/arr059.svg';

/**
 * @todo: Remove and use ICON_CLOSE instead
 */
export const ICON_X = './assets/media/icons/duotune/arrows/arr011.svg';

